<template>
  <div
    class="product-filter-modal"
    v-if="showFilterModal"
    :class="{'active': filterModalActive}"
  >
    <div class="modal">
      <div
        class="modal-header"
      >
        <span
          @click="hideModal"
          class="close-filter-modal-button"
        >Kapat</span>
        <span>Filtre</span>
      </div>
      <div
        class="modal-body"
        :class="{'sub-modal-open': subModalOpen}"
      >
        <div class="row">
          <label>Barkod</label>
          <div>
            <input
              v-model="params.barcode"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="row">
          <label>Stok Kodu</label>
          <div>
            <input
              v-model="params.stockCode"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="row">
          <label>Model Kodu</label>
          <div>
            <input
              v-model="params.productMainId"
              type="text"
              placeholder=""
              class="form-control"
            >
          </div>
        </div>
        <div class="row">
          <label>Marka</label>
          <BrandSelect
            v-model="params.brandIds"
            @toggleModal="changeSubModalOpen"
            :supplier-product-query-type="supplierProductQueryType"
          />
        </div>
        <div class="row">
          <label>Kategori</label>
          <CategorySelect
            v-model="params.pimCategoryIds"
            name="productCategory"
            :options="getCategoriesList"
            :related-categories="relatedCategories"
            placeholder="Kategori Seçimi"
            @toggleModal="changeSubModalOpen"
          />
        </div>
        <div
          class="row"
          v-if="isSortingActive"
        >
          <label>Sıralama Ölçütü</label>
          <Select
            v-model="params.sortType"
            :options="sortTypes"
            placeholder="Sıralama Ölçütü Seçimi"
          />
        </div>
      </div>
      <div class="modal-footer">
        <div class="btn-container">
          <div class="btn-container-item">
            <button
              class="btn btn-dark"
              @click="reset"
            >
              SIFIRLA
            </button>
          </div>
          <div class="btn-container-item">
            <button
              class="btn btn-trendyol"
              @click="handleFilter"
            >
              FİLTRELE
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BrandSelect from './BrandSelect/Index';
import categoryService from '@/services/category';
import CategorySelect from './CategorySelect/Index';
import Select from '@/components/Select';

export default {
  name: 'FilterModal',
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    supplierProductQueryType: {
      type: [String, null],
      default: null,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Select,
    CategorySelect,
    BrandSelect,
  },
  data () {
    return {
      showFilterModal: false,
      filterModalActive: false,
      filterModalActiveCloseBtn: false,
      sortTypes: [{
        label: 'Satış Fiyatına Göre Büyükten Küçüğe Sırala',
        value: {
          sortField: 'SALE_PRICE',
          sortOrder: 'DESC',
        },
      },
      {
        label: 'Satış Fiyatına Göre Küçükten Büyüğe Sırala',
        value: {
          sortField: 'SALE_PRICE',
          sortOrder: 'ASC',
        },
      },
      {
        label: 'Stok Miktarına Göre Büyükten Küçüğe Sırala',
        value: {
          sortField: 'QUANTITY',
          sortOrder: 'DESC',
        },
      },
      {
        label: 'Stok Miktarına Göre Küçükten Büyüğe Sırala',
        value: {
          sortField: 'QUANTITY',
          sortOrder: 'ASC',
        },
      },
      ],
      categories: [],
      relatedCategories: [],
      subModalOpen: false,
    };
  },
  computed: {
    getCategoriesList () {
      return this.categories;
    },
    isSortingActive () {
      if (['ARCHIVED', 'ACTION_NEEDED'].indexOf(this.supplierProductQueryType) > -1) {
        return false;
      }

      return true;
    },
  },
  methods: {
    handleFilter () {
      this.$emit('onFilter', this.params);
      this.hideModal();
    },
    reset () {
      this.params = {
        sortType: {},
        brandIds: {},
        pimCategoryIds: {},
        page: 0,
        size: 10,
      };
      this.handleFilter();
    },
    showModal () {
      document.querySelector('.vue-pull-to-wrapper').style.transform = 'none';
      document.querySelector('.vue-pull-to-wrapper').style.transition = 'none';
      this.showFilterModal = true;
      document.body.style.overflowY = 'hidden';
      setTimeout(() => { this.filterModalActive = true; }, 250);
      setTimeout(() => { this.filterModalActiveCloseBtn = true; }, 500);
    },
    hideModal () {
      this.filterModalActiveCloseBtn = false;
      document.body.style.overflowY = '';
      setTimeout(() => { this.filterModalActive = false; }, 250);
      setTimeout(() => { this.showFilterModal = false; }, 750);

      this.$emit('hideFilterModal');
    },
    async getProductCategoriesBySupplier (supplierProductQueryType) {
      const response = await categoryService.getProductCategoriesBySupplier({ type: supplierProductQueryType });
      const relatedCategories = response.categoryIds;
      return relatedCategories;
    },
    async getCategories () {
      const response = await categoryService.getCategories();
      this.relatedCategories = await this.getProductCategoriesBySupplier(this.supplierProductQueryType);
      this.categories = response.Categories;
    },
    changeSubModalOpen (show) {
      if (show) {
        this.subModalOpen = true;
      } else {
        setTimeout(() => {
          this.subModalOpen = false;
        }, 1000);
      }
    },
  },
  async created () {
    this.params.barcode = this.$route.query.barcode ? this.$route.query.barcode : null;
    if (this.params.barcode) {
      this.handleFilter();
    }
    this.getCategories();
  },
  watch: {
    show () {
      if (this.show) {
        this.showModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .product-filter-modal {
    z-index: 1;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition: all ease .1s;
    height: 100%;

    &:before {
      content: '';
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      background-color: rgba(39, 49, 66, .5);
      opacity: 0;
      transition: opacity ease 1s;
    }

    .modal {
      position: fixed;
      z-index: 2;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #fff;
      border-radius: 15px 15px 0 0;
      transition: transform ease .5s;
      transform: translateY(100%);
      height: 100%;

      .modal-header {
        text-align: center;
        padding: 0 15px;

        margin-bottom: 20px;

        .close {
          display: inline-block;
          width: 20px;
          position: relative;

          &:before,
          &:after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            width: 20px;
            height: 4px;
            background-color: rgb(149, 161, 181);
            border-radius: 2px;
            transition: all ease .5s;
          }

          &.active {
            &:before {
              left: 0;
              transform: rotate(45deg);
            }

            &:after {
              right: 0;
              transform: rotate(-45deg);
            }
          }
        }
      }

      .modal-body {
        height: calc(100vh - 125px);
        padding: 0 15px;
        overflow: hidden;
        overflow-y: auto;
        .row {
          margin-bottom: 10px;

          .date-picker {
            display: flex;

            .date-picker-item {
              padding-right: 8px;
              flex: 1;

              &:last-child {
                padding-left: 7px;
                padding-right: 0;
              }
            }
          }
          label {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 10px;
            display: block;
          }
          &::v-deep .form-control {
            margin-bottom: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
        &.sub-modal-open {
          overflow: initial;
        }
      }

      .modal-footer {
        padding: 20px 15px 15px;

        .btn-container {
          display: flex;

          .btn-container-item {
            padding-right: 8px;
            flex: 1;

            &:last-child {
              padding-left: 7px;
              padding-right: 0;
            }
          }
        }
      }

      .modal-header {
        display: flex;
        height: 40px;
        padding: 0 20px;
        margin-bottom: 8px;
        align-items: center;
        gap: calc((100% / 2) - 60px);
        .close-filter-modal-button {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #FF5043;
        }
      }
    }

    &.active {
      &:before {
        opacity: 1;
      }

      .modal {
        transform: translateY(0);
      }
    }
  }
</style>
